<style lang="less">
@import "../../../styles/common-table-list.less";
</style>
<template>
    <div class="generalframezz">
       <div class="generalcontent" :style="{width:mywidth+'px',height:myheight+'px'}">
            <div :style="{height:myTitleheight+'px',lineHeight:myTitleheight+'px'}" class="general_title">
                <div class="general_title_left">
                    <div>确认支付状态</div>
                </div>
                <img @click="parentHandleclick()" class="timgclose" src="../user/more/images/ty_close.png" alt='版权登记'/>
            </div>
            <div style="margin-top:20px">支付完成后，系统将在5分钟内下发保单</div>
            <div style="margin-top:60px">
                <button class="getBtn" @click="pay" style="margin-right:20px">已支付</button>
                <button class="getBtn" @click="noPay">未支付</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {getInsurance,getInsuranceUrl} from '@/api/staticPage';
    export default {
        name:'insurancePayModel',
        props:{
            mywidth:{
                type:String,
                default:'400'
            },
            myheight:{
                type:String,
                default:'260'
            },
            myTitleheight:{
                type:String,
                default:'63'
            },
            tishihide:{
                type:Boolean,
                default:true
            },
            msgVal:{
				type: String,
				default: ''
            }, //这样可以指定传入的类型，如果类型不对，会警告
            msgType:{
				type: Number,
				default:0
            }, //这样可以指定传入的类型，如果类型不对，会警告
        },
        components: {
        },
        data(){
            return{
                
            }
        },
        mounted() {
            console.log(this.msgVal)
            console.log(this.msgType)
        },
        methods:{
            pay(){
                this.$emit('fatherModal');
            },
            noPay(){
                let data = {
                    refSeqNo:this.msgVal,
                    type:this.msgType
                }
                getInsuranceUrl(data).then(res=>{
                    if(res.code == 200){
                        window.open(res.result)
                        // this.$emit('fatherModal');
                    }else{
                        toast(res.message)
                    }
                })
            },
            parentHandleclick() {
               this.$emit('fatherModal');
            },  
        }
    }
</script>

<style scoped lang="less">
    .generalframezz{
        background: rgba(0, 0, 0, 0.7);
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        text-align: center;
        margin: auto;
        z-index: 558;
        .generalcontent{
            background:#fff;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
            border-radius:8px;
            .general_title{
                background:rgba(255,255,255,1);
                box-shadow:0px 2px 18px 0px rgba(211,214,225,0.15);
                border-radius:8px 8px 0px 0px;
                font-size:14px;
                font-weight:400;
                color:rgba(51,51,51,1);
                display:flex;
                justify-content: space-between;
                padding:0 30px 0 20px;
                align-items: center;
                .general_title_left{
                    display:flex;
                    justify-content: flex-start;
                    align-items: center;
                }
                .timgtishi{
                    width:25px;
                    height:25px;
                    margin-right:10px;
                }
                .timgclose{
                    width:18px;
                    height:18px;
                    cursor: pointer;
                }
            }
            .modal-title{
                margin:15px 0 9px 20px;
                font-size:14px;
                font-weight:400;
                color:rgba(102,102,102,1);
                text-align: left;
            }
            .invice-table-title{
                width:559px;
                height:40px;
                line-height: 40px;
                text-align: center;
                background:rgba(251,251,251,1);
                margin:0 20px;
            }
            .invice-table-content{
                width: 559px;margin: 0 auto;
                font-size:14px;
                font-weight:400;
                color:rgba(153,153,153,1);
                border-bottom: 1px solid #EEEEEE;
                div{
                    margin:15px 0;
                    /*width:200px;*/
                    height: 20px;
                    line-height: 1;
                    /*overflow: hidden;*/
                    /*text-overflow: ellipsis;*/
                    /*white-space: nowrap;*/
                }
                .onecol{
                    text-align: left;
                    padding-left: 10px;
                }
                .imgbox{
                    width: 12px;
                    height: 12px;
                    margin-right: 10px;
                    cursor: pointer;
                    vertical-align: super;
                }
            }
            .getBtn{
                width:124px;
                height:42px;
                line-height: 42px;
                border:0;
                background:rgba(255,216,0,1);
                border-radius:4px;
                text-align: center;
                outline: none;
                font-size:14px;
                font-weight:400;
                color:rgba(25,25,25,1);
                cursor: pointer;
            }
        }
    }
</style>